var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Dialog from "@/components/common/dialog/Dialog.vue";
import Button from "@/components/ui/button/Button.vue";
import { computed, ref } from "vue";
// import { getMonthName } from "@/lib/intl-formatters";
import { currentUser } from "@/core/users/session";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldChangeReviewDialog',
    props: {
        changeReviewService: { type: null, required: true },
        dataRows: { type: Array, required: true },
        tab: { type: String, required: true }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        // Dialog ref
        const dialogRef = ref();
        // State
        const selectedRequest = ref(null);
        const comment = ref("");
        const isProcessing = ref(false);
        const actionType = ref(null);
        const showSuccessMessage = ref(false);
        const successMessage = ref("");
        // Computed
        const changeRequests = computed(() => props.changeReviewService.changeRequests.value);
        const isLoading = computed(() => props.changeReviewService.isLoading.value);
        const canSubmit = computed(() => comment.value.trim().length > 0);
        // const isDistribuidor = computed(() => ["E100"].includes(currentUser().region_code));
        // const isDelegacionZonaVentas = computed(() => ["E300"].includes(currentUser().region_code));
        const isRedRevisada = computed(() => ["N100", "N300", "E100"].includes(currentUser().region_code));
        const isNumObjetivos = computed(() => ["E300"].includes(currentUser().region_code));
        const formatRedValue = (value) => {
            if (value == null)
                return "-";
            return `${value}%`;
        };
        // Methods
        const open = () => {
            var _a;
            selectedRequest.value = null;
            comment.value = "";
            isProcessing.value = false;
            actionType.value = null;
            showSuccessMessage.value = false;
            successMessage.value = "";
            return ((_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.open()) || Promise.resolve({ action: "close" });
        };
        const handleClose = () => {
            var _a, _b;
            if (!isProcessing.value) {
                // If showing success message, return data=true to trigger reload
                if (showSuccessMessage.value) {
                    (_a = dialogRef.value) === null || _a === void 0 ? void 0 : _a.close({ action: "accept", data: true });
                }
                else {
                    (_b = dialogRef.value) === null || _b === void 0 ? void 0 : _b.close({ action: "close" });
                }
            }
        };
        const selectRequest = (request) => {
            selectedRequest.value = request;
            comment.value = "";
        };
        // const getObjectiveName = (objectiveId: string): string => {
        //   const objective = props.objectives.find((obj) => obj.id === objectiveId);
        //   return objective?.name || objectiveId;
        // };
        // const formatPeriod = (period: { year: number; month: number }): string => {
        //   return `${getMonthName(period.month)} ${period.year}`;
        // };
        const handleApprove = () => __awaiter(this, void 0, void 0, function* () {
            if (!selectedRequest.value || !canSubmit.value)
                return;
            isProcessing.value = true;
            actionType.value = "approve";
            try {
                yield props.changeReviewService.approveChange(selectedRequest.value, comment.value, props.tab);
                // Success - show confirmation message
                successMessage.value = "Los cambios han sido aprobados exitosamente.";
                showSuccessMessage.value = true;
                selectedRequest.value = null;
                comment.value = "";
            }
            catch (err) {
                alert("Error al aprobar los cambios. Por favor, intenta de nuevo.");
                console.error("Error approving change:", err);
            }
            finally {
                isProcessing.value = false;
                actionType.value = null;
            }
        });
        const handleReject = () => __awaiter(this, void 0, void 0, function* () {
            if (!selectedRequest.value || !canSubmit.value)
                return;
            isProcessing.value = true;
            actionType.value = "reject";
            try {
                yield props.changeReviewService.rejectChange(selectedRequest.value, comment.value, props.tab);
                // Success - show confirmation message
                successMessage.value = "Los cambios han sido rechazados exitosamente.";
                showSuccessMessage.value = true;
                selectedRequest.value = null;
                comment.value = "";
            }
            catch (err) {
                alert("Error al rechazar los cambios. Por favor, intenta de nuevo.");
                console.error("Error rejecting change:", err);
            }
            finally {
                isProcessing.value = false;
                actionType.value = null;
            }
        });
        // Expose methods
        __expose({
            open,
        });
        const __returned__ = { props, dialogRef, selectedRequest, comment, isProcessing, actionType, showSuccessMessage, successMessage, changeRequests, isLoading, canSubmit, isRedRevisada, isNumObjetivos, formatRedValue, open, handleClose, selectRequest, handleApprove, handleReject, Dialog, Button };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
